/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { DialogBaseComponent } from '../dialogs/dialog-base.component';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog.component';
import { InformationChartDialogComponent } from '../information-chart-dialog/information-chart-dialog.component';

export interface ConfirmDialogOptions {
  title?: string;
  body?: string;
  hideCancelButton?: boolean;
}

export interface DialogResult<T> {
  isSubmitted: boolean;
  isCancelled: boolean;
  isDismissed: boolean;
  value?: T;
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private componentRef?: ComponentRef<DialogBaseComponent>;
  private dialogResultSubject?: Subject<DialogResult<any>>;

  constructor() { }

  show(entry: ViewContainerRef | undefined, content: Type<DialogBaseComponent>, options: unknown = null, dialogInformationId?: string): Observable<DialogResult<any>> {
    if (entry) {
      entry.clear();
      this.componentRef = entry.createComponent(content);
      this.componentRef.instance.options = options;

      if (dialogInformationId) {
        (this.componentRef.instance as InformationChartDialogComponent).dialogInformationId = dialogInformationId;
      }
      this.componentRef.instance.completeEvent.subscribe((dialogResult) => this.complete(dialogResult));
    }
    this.dialogResultSubject = new Subject<DialogResult<any>>();
    return this.dialogResultSubject.asObservable();
  }

  confirm(entry: ViewContainerRef | undefined, options: ConfirmDialogOptions): Observable<DialogResult<any>> {
    if (entry) {
      entry.clear();
      this.componentRef = entry.createComponent(ConfirmDialogComponent);
      this.componentRef.instance.options = options;
      this.componentRef.instance.completeEvent.subscribe((dialogResult) => this.complete(dialogResult));
    }
    this.dialogResultSubject = new Subject<DialogResult<any>>();
    return this.dialogResultSubject.asObservable();
  }

  close() {
    this.dialogResultSubject?.complete();
    this.componentRef?.instance.setIsClosing(true);
    setTimeout(() => {
      this.componentRef?.destroy();
    }, 600);
  }

  complete(dialogResult: DialogResult<any>) {
    this.dialogResultSubject?.next(dialogResult);
    this.close();
  }
}
